import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Plan from '@/components/plan/Plan'
import Charge from '@/components/charge/Charge'
import Success from '@/components/success/Success'
import Today from '@/components/today/Today'
import Mypage from '@/components/mypage/Mypage'
import Login from '@/components/login/Login'
import Forget from '@/components/forget/Forget'
import Resign from '@/components/resign/Resign'
import ConnectSetting from '@/components/connectSetting/ConnectSetting'
import ChangeMail from '@/components/confirmation/ChangeMail'
import ChangePassword from '@/components/confirmation/ChangePassword'
import Recipe from '@/components/recipe/Recipe'
import Manager from '@/components/manager/Manager'
import List from '@/components/list/List'
import ConfirmMailForChangeCard from '@/components/confirmMailForChangeCard/ConfirmMailForChangeCard'
import ChangeChargeCard from '@/components/changeChargeCard/ChangeChargeCard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/plan',
      name: 'Plan',
      component: Plan
    },
    {
      path: '/charge',
      name: 'Charge',
      component: Charge
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/mypage',
      name: 'Mypage',
      component: Mypage
    },
    {
      path: '/today',
      name: 'Today',
      component: Today
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forget',
      name: 'Forget',
      component: Forget
    },
    {
      path: '/resign',
      name: 'Resign',
      component: Resign
    },
    {
      path: '/connectSetting',
      name: 'ConnectSetting',
      component: ConnectSetting 
    },
    {
      path: '/changeMail',
      name: 'ChangeMail',
      component: ChangeMail
    },
    {
      path: '/changePassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/recipe',
      name: 'Recipe',
      component: Recipe
    },
    {
      path: '/manager',
      name: 'Manager',
      component: Manager
    },
    {
      path: '/list',
      name: 'List',
      component: List
    },
    {
      path: '/confirmMailForChangeCard',
      name: 'ConfirmMailForChangeCard',
      component: ConfirmMailForChangeCard
    },
    {
      path: '/changeChargeCard',
      name: 'ChangeChargeCard',
      component: ChangeChargeCard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js